import script from "./B2bFeeDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./B2bFeeDialog.vue?vue&type=script&lang=ts&setup=true"

import "./B2bFeeDialog.vue?vue&type=style&index=0&id=163c9c0e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163c9c0e"]])

export default __exports__